import React from 'react';
import { Mail, Send, Users, LineChart, Filter, ChevronLeft, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function EmailAutomation() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <header className="bg-white shadow-sm">
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center space-x-6">
            <Link to="/" className="flex items-center space-x-2 text-indigo-600 hover:text-indigo-700">
              <ChevronLeft className="w-5 h-5" />
              <span>Back to Home</span>
            </Link>
            <a 
              href="https://wa.me/60177751631"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-green-600 hover:text-green-700"
            >
              <MessageCircle className="w-5 h-5" />
              <span>Contact on WhatsApp</span>
            </a>
          </div>
        </nav>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="text-center mb-16">
          <Mail className="w-16 h-16 text-indigo-600 mx-auto mb-4" />
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Automation Templates</h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Powerful automation templates for email and social media that drive engagement and growth.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <img 
              src="https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?auto=format&fit=crop&q=80"
              alt="Email Marketing Dashboard"
              className="w-full h-64 object-cover"
            />
            <div className="p-6">
              <h3 className="text-xl font-bold mb-4">Template Categories</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• Email Templates</li>
                <li className="pl-4">- Welcome Series</li>
                <li className="pl-4">- Lead Nurturing</li>
                <li className="pl-4">- Product Announcements</li>
                <li>• Make.com Templates</li>
                <li className="pl-4">- Social Media Content Generation</li>
                <li className="pl-4">- Multi-Platform Publishing</li>
                <li className="pl-4">- Engagement Tracking</li>
              </ul>
            </div>
          </div>
          <div>
            <h2 className="text-2xl font-bold mb-6">Key Features</h2>
            <div className="space-y-4">
              <div className="flex items-start">
                <Send className="w-6 h-6 text-indigo-600 mt-1 mr-3" />
                <div>
                  <h3 className="font-semibold mb-1">Email Templates</h3>
                  <p className="text-gray-600">Ready-to-use templates for automated email campaigns and responses.</p>
                </div>
              </div>
              <div className="flex items-start">
                <Users className="w-6 h-6 text-indigo-600 mt-1 mr-3" />
                <div>
                  <h3 className="font-semibold mb-1">Make.com Templates</h3>
                  <p className="text-gray-600">Generate 101 AI posts weekly for Instagram, Facebook, TikTok, YouTube, LinkedIn & Telegram.</p>
                </div>
              </div>
              <div className="flex items-start">
                <Filter className="w-6 h-6 text-indigo-600 mt-1 mr-3" />
                <div>
                  <h3 className="font-semibold mb-1">Content Types</h3>
                  <p className="text-gray-600">Automated generation of videos, images, and text posts for all platforms.</p>
                </div>
              </div>
              <div className="flex items-start">
                <LineChart className="w-6 h-6 text-indigo-600 mt-1 mr-3" />
                <div>
                  <h3 className="font-semibold mb-1">Performance Analytics</h3>
                  <p className="text-gray-600">Track engagement and performance across all platforms.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center">
          <Link 
            to="/#contact"
            className="inline-flex items-center bg-primary text-white px-8 py-3 rounded-lg hover:bg-accent transition"
          >
            Get Started with Automation
          </Link>
        </div>
      </div>
    </div>
  );
}